import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-21a46971")
const _hoisted_1 = { class: "p-grid" }
const _hoisted_2 = { class: "p-col" }
const _hoisted_3 = { class: "p-grid" }
const _hoisted_4 = { class: "rank-title p-col-12" }
const _hoisted_5 = { class: "p-grid" }
const _hoisted_6 = { class: "p-col" }
const _hoisted_7 = { class: "p-col" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "others-title p-col-12" }, " NPS SCORE ", -1)
const _hoisted_9 = { class: " p-grid" }
const _hoisted_10 = { class: "p-col" }
const _hoisted_11 = { class: "p-grid" }
const _hoisted_12 = { class: "rank-title p-col-12" }
const _hoisted_13 = { class: "p-grid" }
const _hoisted_14 = { class: "p-col" }
const _hoisted_15 = { class: "p-col" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "p-col-12" }, [
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_17 = { class: "p-grid" }
const _hoisted_18 = { class: "p-col" }
const _hoisted_19 = { class: "p-grid" }
const _hoisted_20 = { class: "rank-title p-col-12" }
const _hoisted_21 = { class: "p-grid" }
const _hoisted_22 = { class: "p-col" }
const _hoisted_23 = { class: "p-col" }
const _hoisted_24 = { class: "score p-col-12" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tag = _resolveComponent("Tag")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createBlock(_component_DataTable, {
    responsiveLayout: "scroll",
    value: _ctx.data
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Column, {
        field: "detractors",
        header: "Detractores",
        style: {"padding-right":"0px"}
      }, {
        body: _withCtx(({data}) => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(data.detractors.value), 1),
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_Tag, { class: "black p-tag-red-brain" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(data.detractors.perc.toFixed(0)) + "%", 1)
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ])
                ]),
                _hoisted_8
              ])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_Column, {
        field: "passives",
        header: "Pasivos",
        style: {"padding":"12px 0px"}
      }, {
        body: _withCtx(({data}) => [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, _toDisplayString(data.passives.value), 1),
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_Tag, { class: "black p-tag-yellow-brain" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(data.passives.perc.toFixed(0)) + "%", 1)
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ])
                ]),
                _hoisted_16
              ])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_Column, {
        field: "promotoers",
        header: "Promotores",
        style: {"padding-left":"0px"}
      }, {
        body: _withCtx(({data}) => [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, _toDisplayString(data.promoters.value), 1),
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(_component_Tag, { class: "black p-tag-light-green-brain" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(data.promoters.perc.toFixed(0)) + "%", 1)
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.npsScore.toFixed(2)), 1)
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["value"]))
}